import { FormHelperText, Grid, Typography } from '@material-ui/core'
import { DatePicker } from 'components/UI'
import { getApprovalValues } from 'ducks/selectors'
import { useSelector } from 'react-redux'
import useStyles from './styles'
import { FC } from 'react'
import moment from 'moment'
import { useStepperContext } from 'hooks/useStepperContext'
import BooleanCheckbox from 'components/UI/CustomUI/molecules/BooleanCheckbox'

export interface PropertyStatusProps {
  isHomeowner: boolean
}

const PropertyStatus: FC<PropertyStatusProps> = ({ isHomeowner }) => {
  const classes = useStyles()
  const { showWarnings, saveNewValue } = useStepperContext()

  const {
    closingDate,
    preferredStartDate,
    propertyUnderContract,
    completedBeforeClosing,
    propertyToBeSold,
    propertyListed,
  } = useSelector(getApprovalValues())

  return (
    <>
      <Typography className={classes.title} style={{ padding: '0' }}>
        📁 {isHomeowner ? 'PLEASE CONFIRM OR UPDATE' : 'PROPERTY STATUS'}
      </Typography>
      <Grid container spacing={2}>
        {isHomeowner && (
          <Grid item xs={12} lg={6}>
            <Typography variant="body1" className={classes.latoPrimaryText}>
              <span style={{ color: showWarnings && propertyToBeSold == null ? 'red' : undefined }}>*</span> Are you selling or preparing to sell your home?
            </Typography>
            <BooleanCheckbox
              onChange={(ev) => {
                if (ev.target.value === 'false') {
                  saveNewValue('closingDate', undefined)
                  saveNewValue('completedBeforeClosing', undefined)
                  saveNewValue('propertyUnderContract', undefined)
                  saveNewValue('paymentOption', 'pay_at_completion')
                  saveNewValue('agentAsHomeownerRepresentative', null)
                }
                saveNewValue('propertyToBeSold', ev.target.value === 'true')
              }}
              value={propertyToBeSold}
              error={showWarnings && propertyToBeSold == null}
            />
            {showWarnings && propertyToBeSold == null && (
              <FormHelperText error>Please select an option.</FormHelperText>
            )}
          </Grid>
        )}
        {(propertyToBeSold || !isHomeowner) && (
          <>
            <Grid item xs={12} lg={6}>
              <Typography variant="body1" className={classes.latoPrimaryText}>
                <span style={{ color: showWarnings && propertyUnderContract == null ? 'red' : undefined }}>*</span> Is the property under contract?
              </Typography>
              <BooleanCheckbox
                onChange={(ev) => {
                  if (ev.target.value === 'false') {
                    saveNewValue('closingDate', undefined)
                    saveNewValue('completedBeforeClosing', undefined)
                  } else {
                    saveNewValue('propertyListed', undefined)
                  }
                  saveNewValue(
                    'propertyUnderContract',
                    ev.target.value === 'true'
                  )
                }}
                value={propertyUnderContract}
                error={
                  showWarnings && propertyUnderContract == null
                }
              />
              {showWarnings && propertyUnderContract == null && (
                <FormHelperText error>Please select an option.</FormHelperText>
              )}
            </Grid>
            {propertyUnderContract !== undefined &&
              propertyUnderContract !== null &&
              (!propertyUnderContract && isHomeowner ? (
                <Grid item xs={12} lg={6}>
                  <Typography
                    variant="body1"
                    className={classes.latoPrimaryText}
                  >
                    <span style={{ color: showWarnings && propertyListed == null ? 'red' : undefined }}>*</span> Is the property currently listed?
                  </Typography>
                  <BooleanCheckbox
                    onChange={(ev) => {
                      saveNewValue('propertyListed', ev.target.value === 'true')
                    }}
                    value={propertyListed}
                    error={
                      showWarnings && propertyListed == null
                    }
                  />
                  {showWarnings && propertyListed == null && (
                    <FormHelperText error>Please select an option.</FormHelperText>
                  )}
                </Grid>
              ) : (
                propertyUnderContract && (
                  <Grid item xs={12} lg={6}>
                    <Typography className={classes.latoPrimaryText}>
                      <span style={{ color: showWarnings && (closingDate == null || (typeof closingDate === 'number' && closingDate <= 0)) ? 'red' : undefined }}>*</span> What is the closing date?
                    </Typography>
                    <Grid>
                      <DatePicker
                        error={
                          showWarnings && (closingDate == null || (typeof closingDate === 'number' && closingDate <= 0))
                        }
                        minDate={
                          preferredStartDate
                            ? moment(preferredStartDate).toDate()
                            : new Date()
                        }
                        onChange={(date: Date) =>
                          saveNewValue('closingDate', date.valueOf() / 1000)
                        }
                        value={
                          closingDate
                            ? moment(closingDate * 1000).toDate()
                            : null
                        }
                      />
                      {showWarnings && (closingDate == null || (typeof closingDate === 'number' && closingDate <= 0)) && (
                        <FormHelperText error>Closing date is required.</FormHelperText>
                      )}
                    </Grid>
                  </Grid>
                )
              ))}

            {isHomeowner &&
              propertyUnderContract !== undefined &&
              propertyUnderContract !== null &&
              propertyUnderContract && (
                <Grid item xs={12} lg={6}>
                  <Typography
                    variant="body1"
                    className={classes.latoPrimaryText}
                  >
                    <span style={{ color: showWarnings && completedBeforeClosing == null ? 'red' : undefined }}>*</span> Will the repairs be completed prior to the closing date?
                  </Typography>
                  <BooleanCheckbox
                    onChange={(ev) => {
                      saveNewValue(
                        'completedBeforeClosing',
                        ev.target.value === 'true'
                      )
                    }}
                    value={completedBeforeClosing}
                    error={
                      showWarnings &&
                      completedBeforeClosing == null
                    }
                  />
                  {showWarnings && completedBeforeClosing == null && (
                    <FormHelperText error>Please select an option.</FormHelperText>
                  )}
                </Grid>
              )}
          </>
        )}
      </Grid>
    </>
  )
}

export default PropertyStatus
